export default __webpack_public_path__ + "static/media/provincial.0e652df4.png";